import _ from 'underscore'
import React from 'react'
import Modernizr from './lib/modernizr'

import parseUserAgent from './parse-user-agent'
import supported from './supported.yaml'
import text from './localization/en-US.yaml'
import thresholds from './thresholds.yaml'


const supportedBrowsers = _.keys(supported.Browsers)

export const status = {
  success: 'success',
  warning: 'warning',
  error: 'error'
}

/**
 * This file is all of the checks used for
 * functionality work. Each (with the
 * exception of the browser check) returns
 * a promise with indicating the status and
 * display text.
 */
export function browser (uaBrowser) {
  const {name, version} = uaBrowser,
        browserText = text['Browser Check'],
        versionMajor = /(\d+\.)/.exec(version)[1]

  let result = {
    status: status.error,
    text: browserText.Unsupported
  }

  if (_.contains(supportedBrowsers, name)) {
    const supportedVersion = supported.Browsers[name].min <= versionMajor

    if (supportedVersion) {
      result = {
        status: status.success,
        text: browserText.Supported
      }
    }
    else {
      result = {
        status: status.warning,
        text: browserText['Out of date']
      }
    }
  }

  return result

}

export function cookies () {
  const cookieText = text['Cookie Check'],
        {name} = parseUserAgent().browser
  let result = {
    text: cookieText.Failure[name] ||
          cookieText.Failure.Default,
    status: status.error
  }

  if (Modernizr.cookies) {
    result = {
      text: cookieText.Pass,
      status: status.success
    }
  }

  return new Promise(resolve => resolve(result))
}

export function flash () {
  const flashText = text['Adobe Flash']
  let result = {
    text: flashText.Failure,
    status: status.error
  }

  window.Modernizr = Modernizr

  if (Modernizr.flash) {
    result = {
      text: `Version: ${navigator.plugins['Shockwave Flash'].version}`,
      status: status.success
    }
  }

  return new Promise(resolve => resolve(result))
}

/*
 * Effectively a no-op because of how JS intensive React is.
 */
export function javascript() {
  return new Promise(resolve => resolve({
    text: '',
    status: status.success
  }))
}

export function popups () {
  const popup = window.open('_blank')

  if (popup) {
    popup.close()
    return new Promise(resolve => resolve({
      text: '',
      status: status.success
    }))
  }

  const popupText = text['Popup Window Check'],
        {name} = parseUserAgent().browser

  return new Promise(resolve => resolve({
    text: popupText.Failure[name] ||
          popupText.Failure.Default,
    status: status.error
  }))
}

export function http () {
  const headers = new Headers()
  headers.append('cache-control', 'no-store')
  const init = {
    method: 'GET',
    headers
  }
  const request = new Request('img/logo1.png')

  return fetch(request, init)
      .then(() => new Promise(resolve => resolve({
        text: '',
        status: status.success
      }))
      ).catch(() => new Promise(resolve => resolve({
        status: status.error,
        text: text['Port 80 Check'].Failure
      })
      ))

}

const comparisons = {
  lessThan (a, b) { return a < b },
  greaterThan (a, b) { return a > b }
}

function gradeAgainstThresholds (args) {
  const {
    comparison,
    measurement,
    result,
    thresholds,
  } = args

  return () => {
    if (comparison(result, thresholds.error)) {
      const message = text[measurement].Failure

      return new Promise(resolve => resolve({
        text: `${result} ${thresholds.unit}, ${message}`,
        status: status.error
      }))
    }
    else if (comparison(result, thresholds.warn)) {
      const message = text[measurement].Failure

      return new Promise(resolve => resolve({
        text: `${result} ${thresholds.unit}, ${message}`,
        status: status.warning
      }))
    }

    const message = text[measurement].Pass

    return new Promise(resolve => resolve({
      text: `${result} ${thresholds.unit}, ${message}`,
      status: status.success
    }))
  }
}

export function downloadSpeed (downloadSpeed) {
  const downloadThresholds = thresholds.speed.download

  return gradeAgainstThresholds({
    comparison: comparisons.lessThan,
    measurement: 'Download Test',
    result: downloadSpeed,
    thresholds: downloadThresholds,
  })
}

export function uploadSpeed (uploadSpeed) {
  const uploadThresholds = thresholds.speed.upload

  return gradeAgainstThresholds({
    comparison: comparisons.lessThan,
    measurement: 'Upload Test',
    result: uploadSpeed,
    thresholds: uploadThresholds,
  })
}

export function jitter (jitter) {
  const jitterThresholds = thresholds.speed.jitter

  return gradeAgainstThresholds({
    comparison: comparisons.greaterThan,
    measurement: 'Jitter Test',
    result: jitter,
    thresholds: jitterThresholds,
  })
}

export function latency (latency) {
  const latencyThresholds = thresholds.speed.latency

  return gradeAgainstThresholds({
    comparison: comparisons.greaterThan,
    measurement: 'Latency Test',
    result: latency,
    thresholds: latencyThresholds,
  })
}

export function Check (props) {
  const {status} = props
  return (
    <td className={'check-result'}>
      <div className={status}></div>
    </td>
  )
}


// WEBPACK FOOTER //
// ./app/check.js